/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import {
  Modal, Label, Dropdown, Checkbox, Popup, List, Icon, Radio
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import cx from 'classnames';
import { v4 as uuidv4 } from 'uuid';
import Update from 'immutability-helper';
import api from '../../api';
import Loader from '../Loader/Loader';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import userPic from '../../images/common/profile_icon_big.png';
import DeleteProjectModal from './DeleteProjectModal';
import AssigningProjectModal from './AssigningProjectModal';
import WithRouter from '../Extensions/WithRouter';

class EditUserModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMEU: props.isOpenMEU,
      userId: props.userId,
      modalIsOpen: false,
      isOpenMDP: false,
      isOpenMAP: false,
      isShowLoader: false,
      isLoading: false,
      resetPage: false,
      itemsChecked: false,
      source: '',
      id: '',
      userName: '',
      email: '',
      assignedProject: [],
      checkValue: [],
      memberList: {
        group_list: [],
        member_list: [],
      },
      modalAlertMsg: '',
      modalAlertTitle: '',
      modalAlert: false,
      isLoader: false,
      isResetPassword: false,
      isAuthChangable: false,
      isProjectAssignable: false,
      isStatusChangable: false,
      isDeletable: false,
      popupStatus: false,
      status: 'inactive',
      activeIndex: '',
      authorizedIps: 'all',
      selectedIps: '',
      isIpChangeable: false,
      ipsError: '',
      globalError: '',
    };
    this.handleAuthChange = this.handleAuthChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleProjectCheckAll = this.handleProjectCheckAll.bind(this);
    this.handleRemoveUser = this.handleRemoveUser.bind(this);
    this.handleMDPClose = this.handleMDPClose.bind(this);
    this.handleProjectCheckChange = this.handleProjectCheckChange.bind(this);
    this.handleAddProject = this.handleAddProject.bind(this);
    this.handleRemoveProject = this.handleRemoveProject.bind(this);
    this.handleProjectList = this.handleProjectList.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleMAPClose = this.handleMAPClose.bind(this);
    this.handleCloseAlert = this.handleCloseAlert.bind(this);
    this.handleDeleteCallback = this.handleDeleteCallback.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleResponse = this.handleResponse.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleRadioChange = this.handleRadioChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.closeEditUserModal = this.closeEditUserModal.bind(this);
    this.closeResetModal = this.closeResetModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { isOpenMEU, userId } = this.props;

    if (isOpenMEU !== prevProps.isOpenMEU) {
      this.setState({
        isOpenMEU,
        userId,
        //selectedProjectList: [],
        //company: '',
        //companyError: '',
        checkValue: [],
        itemsChecked: false,
        //file: {
        //error: false,
        //value: '',
        //errorMsg: '',
        //preview: null,
        //image: null,
        //},
        popupStatus: false,
        activeIndex: '',
        memberList: {
          group_list: [],
          member_list: [],
        },
        authorizedIps: 'all',
        selectedIps: '',
        isIpChangeable: false,
        ipsError: '',
        globalError: '',
      }, () => {
        this.getUserDetail(this.props);
      });
    }
  }

  handleScroll = () => {
    this.handlePopupClose();
  };

  handlePopupClose() {
    this.setState({
      popupStatus: false,
      activeIndex: '',
    });
  }

  handleSave() {
    const { authorizedIps, selectedIps, permission } = this.state;
    const { translate } = this.props;
    const projectId = [];
    let ips = [];
    const formData = new FormData();

    if (this.props.state.user.isAdmin) {
      formData.append('status', this.state.status);
    }

    if (this.props.state.user.isAdminOnly) {
      formData.append('selected_role', this.state.permission);
    }

    if (!this.props.state.user.isSuperAdmin) {
      if (this.state.assignedProject.length !== 0) {
        this.state.assignedProject.map((item) => {
          return projectId.push(item.id);
        });
      }
      let i = 0;
      for (i; i < projectId.length; i++) {
        formData.append('project_ids[]', projectId[i]);
      }
    }

    if (authorizedIps === 'specific') {
      if (selectedIps.trim().length === 0) {
        return this.setState({
          ipsError: translate('profile.error.one_ip_address'),
        });
      }
      const ipsArray = this.separateString(selectedIps);
      const regexIpv = /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;
      let i = 0;
      for (i; i < ipsArray.length; i++) {
        if (!regexIpv.test(ipsArray[i])) {
          return this.setState({
            ipsError: translate('profile.error.invalid_ip_address'),
          });
        }
      }
      ips = ipsArray;
    } else {
      ips = [];
    }

    if (permission === 'admin') {
      let j = 0;
      for (j; j < ips.length; j++) {
        formData.append('authorized_ips[]', ips[j]);
      }
    }

    this.setState({
      modalAlert: true,
      isLoader: true,
    });

    api
      .updateUser(this.state.id, formData)
      .then(() => {
        this.setState({
          isLoader: false,
          modalAlertTitle: translate('modal.title.notice'),
          modalAlertMsg: translate('modal.message.update_success_user'),
        });
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;

        if (o.error === '422-226') {
          this.setState({
            isLoader: false,
            modalAlert: false,
            globalError: translate('profile.error.invalid_ip_address'),
          });
        } else if (o.error === '422-375') {
          this.setState({
            isLoader: false,
            modalAlert: false,
            globalError: translate('profile.error.error_422_375'),
          });
        } else {
          this.setState({
            isLoader: false,
            modalAlert: false,
            globalError: o.error_description || translate('modal.error.unknow_error'),
          });
        }

      });
  }

  handleAuthChange(e) {
    this.setState({
      permission: e.currentTarget.dataset.id,
    });
  }

  handleRadioChange(e, { value }) {
    this.setState({
      authorizedIps: value,
    });
  }

  handleInputChange(e) {
    this.setState({
      selectedIps: e.target.value,
      ipsError: '',
    });
  }

  handleReset() {
    const { translate } = this.props;
    const { source } = this.state;
    if (source === 'local') {
      this.modalBody = translate('login.message.reset_password');
      this.modalAction = translate('modal.title.attention');
      this.setState({
        modalIsOpen: true,
      });
    } else {
      this.modalBody = translate('modal.message.unable_reset_password');
      this.modalAction = translate('modal.title.attention');
      this.setState({
        resetPage: true,
        modalIsOpen: true,
      });
    }
  }

  handleProjectCheckAll() {
    const { itemsChecked, assignedProject } = this.state;
    const newState = [];

    if (itemsChecked) {
      this.setState({
        itemsChecked: false,
        checkValue: [],
      });
    } else {
      const newData = assignedProject.filter((item) => {
        if (typeof item.is_project_deletable === 'undefined') {
          return item;
        }
        return item.is_project_deletable === true;
      });

      const num = newData.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(newData[i].id);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        itemsChecked: true,
        checkValue: unique,
      });
    }
  }

  handleProjectCheckChange(e, { value }) {
    const { checkValue } = this.state;
    let newState;
    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValue, value];
    }
    this.setState({
      checkValue: newState,
    });
  }

  handleStatusChange(e, data) {
    const { status } = this.state;
    if (data.value === status) {
      return;
    }
    this.setState({
      status: data.value,
    });
  }

  handleAddProject() {
    this.setState({
      isOpenMAP: true,
    });
  }

  handleRemoveProject() {
    const { checkValue, assignedProject } = this.state;
    if (checkValue.length === 0) {
      return false;
    }
    const newState = assignedProject.filter((item) => {
      return checkValue.indexOf(item.id) === -1;
    });
    this.setState({
      assignedProject: newState,
      checkValue: [],
      itemsChecked: false,
    });
  }

  handleProjectList(newArr) {
    const { assignedProject } = this.state;

    this.setState({
      assignedProject: Update(assignedProject, {
        $push: newArr,
      }),
    });
  }

  handleMAPClose() {
    this.setState({
      isOpenMAP: false,
    });
  }

  handleCloseAlert() {
    this.setState({ modalAlert: false });
    this.props.completeCallback(200);
    this.closeEditUserModal();
  }

  handleRemoveUser() {
    this.setState({
      isOpenMDP: true,
    });
  }

  handleMDPClose() {
    this.setState({
      isOpenMDP: false,
    });
  }

  handleDeleteCallback(statusCode) {
    if (statusCode) {
      this.closeEditUserModal();
    } else {
      console.log('failed to delete');
    }
  }

  handleResponse(message) {
    this.modalBody = message;
    this.setState({
      modalIsOpen: true,
      isShowLoader: false,
      resetPage: true,
    });
  }

  /*
  getByteLength(text) {
    let l = 0;
    for (let i = 0; i < text.length; i++) l += text.charCodeAt(i) > 128 ? 2 : 1;
    // return text.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, '$&$1$2').length;
    return l;
  }
  */

  getUserDetail(Props) {
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getUserDetail(Props.userId)
        .then((response) => {
          const data = response.response;
          let authorizedIps;
          let selectedIps;
          if (data.authorized_ips.length === 0) {
            authorizedIps = 'all';
            selectedIps = '';
          } else {
            authorizedIps = 'specific';
            let i = 0;
            for (i; i < data.authorized_ips.length; i++) {
              if (i === 0) {
                selectedIps = data.authorized_ips[i];
              } else {
                selectedIps = `${selectedIps},${data.authorized_ips[i]}`;
              }
            }
          }

          this.setState({
            id: data.id,
            source: data.source,
            userName: data.user_name,
            email: data.email,
            permission: data.permission,
            companyName: data.user_company_name,
            created: data.created,
            lastModified: data.last_modified,
            lastAccessed: data.last_accessed,
            status: data.status,
            isResetPassword: data.is_reset_password_allowed,
            isAuthChangable: data.is_permission_changeable,
            isProjectAssignable: data.is_project_assignable,
            isStatusChangable: data.is_state_changeable,
            isDeletable: data.is_deletable,
            assignedProject: data.assinged_projects,
            authorizedIps,
            selectedIps,
            isIpChangeable: data.is_authorized_ip_changeable,
            isLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  }

  getProfileImg(value) {
    const profileImg = `/1/users/me/profile_image/${value}`;

    let baseUrl = '//'.concat(location.hostname);
    let profileImgUrl = '';

    if (process.env.NODE_ENV === 'development') {
      baseUrl = baseUrl.concat(':3000');
    } else {
      baseUrl = location.port !== '' ? baseUrl.concat(':', location.port) : '';
    }

    profileImgUrl = profileImg !== '' ? baseUrl.concat(profileImg) : userPic;

    return profileImgUrl;
  }

  getSProjectMemberDetail = (projectId) => {
    api.getSProjectMemberDetail(projectId)
      .then((response) => {
        const data = response.response;
        this.setState({
          memberList: data,
          popupStatus: true,
          activeIndex: projectId,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          //error: t('modal.error.error_load'),
          isLoading: false,
        });
      });
  };

  resetPasswordBtn = () => {
    const { isResetPassword } = this.state;
    const { translate } = this.props;

    if (!isResetPassword) {
      return (
        <div
          className="deep_gray_button"
          style={{
            pointerEvents: 'none',
            cursor: 'default',
            opacity: '.45',
          }}
        >
          {translate('login.menu.reset_password')}
        </div>
      );
    }
    return (
      <div
        className="deep_gray_button"
        onClick={this.handleReset}
        style={{ cursor: 'pointer' }}
      >
        {translate('login.menu.reset_password')}
      </div>
    );
  };

  deleteThisUserBtn = () => {
    const { isDeletable } = this.state;
    const { translate } = this.props;

    if (isDeletable) {
      return (
        <a
          className="red"
          style={{ cursor: 'pointer', lineHeight: '15px' }}
          onClick={this.handleRemoveUser}
        >
          {translate('modal.button.delete_this_user')}
        </a>
      );
    }
    return (
      <a
        className="red"
        style={{
          pointerEvents: 'none',
          cursor: 'default',
          opacity: '.45',
          lineHeight: '15px',
        }}
      >
        {translate('modal.button.delete_this_user')}
      </a>
    );
  };

  modalBtn = () => {
    const { resetPage } = this.state;
    const { translate } = this.props;

    if (resetPage) {
      return (
        <div className="button_wrap">
          <a className="center_button" onClick={this.closeResetModal} style={{ cursor: 'pointer' }}>Ok</a>
        </div>
      );
    }
    return (
      <div className="button_wrap">
        <a
          onClick={this.closeResetModal}
          style={{ cursor: 'pointer' }}
          className="left_button"
        >
          {translate('modal.button.no')}
        </a>
        <a onClick={this.resetPassword} className="right_button">
          {translate('modal.button.yes')}
        </a>
      </div>
    );
  };

  separateString(value) {
    const separatedArray = [];
    const originalString = value.replace(/ /g, '');
    let previousIndex = 0;
    let i = 0;
    for (i; i < originalString.length; i++) {
      if (originalString[i] === ',') {
        const separated = originalString.slice(previousIndex, i);
        separatedArray.push(separated);
        previousIndex = i + 1;
      }
    }
    separatedArray.push(originalString.slice(previousIndex, i));
    return separatedArray;
  }

  closeEditUserModal() {
    this.setState({
      isOpenMEU: false,
    });
    this.props.closeModal();
    this.props.completeCallback(200);
  }

  closeResetModal(e) {
    if (e) {
      e.preventDefault();
      if (e.target.classList[0] === 'right_button') {
        return false;
      }
    }
    this.setState({
      modalIsOpen: false,
      resetPage: false,
      isShowLoader: false,
    });
  }

  resetPassword() {
    const { userId } = this.state;
    const { translate } = this.props;
    const ids = [];
    this.setState({
      isShowLoader: true,
    }, () => {
      ids.push(userId);
      const data = {
        ids,
      };
      api
        .resetUser(data)
        .then((response) => {
          const res = response.response;
          if (!res.is_use_link) {
            this.modalAction = translate('modal.title.notice');
            this.modalBody = translate('modal.message.sent_email');
          } else {
            this.modalAction = translate('modal.title.notice');
            this.modalBody = res.link;
          }
          this.setState({
            modalIsOpen: true,
            isShowLoader: false,
            resetPage: true,
            status: 'inactive',
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;

          if (o.error === '422-361' || o.error === '422-373') {
            this.modalAction = translate('modal.title.attention');
            this.modalBody = translate('modal.error.error_422_361');
          } else if (o.error === '422-368') {
            this.modalAction = translate('modal.title.attention');
            this.modalBody = translate('modal.error.user_server_first');
          } else if (o.error === '422-367') {
            this.modalAction = translate('modal.title.attention');
            this.modalBody = translate('modal.error.user_smtp_first');
          } else if (o.error_description) {
            this.modalAction = translate('modal.title.attention');
            this.modalBody = o.error_description;
          } else {
            this.modalAction = translate('modal.title.attention');
            this.modalBody = translate('modal.error.unknow_error');
          }

          this.setState({
            modalIsOpen: true,
            isShowLoader: false,
            resetPage: true,
          });
        });
    });
  }

  render() {
    const {
      source,
      permission,
      companyName,
      status,
      userName,
      email,
      created,
      lastModified,
      lastAccessed,
      isStatusChangable,
      isAuthChangable,
      isProjectAssignable,
      itemsChecked,
      assignedProject,
      checkValue,
      popupStatus,
      activeIndex,
      isLoading,
      authorizedIps,
      selectedIps,
      isIpChangeable,
    } = this.state;
    const { translate } = this.props;

    const statusValue = [
      { key: 1, text: translate('modal.title.active'), value: 'active' },
      { key: 2, text: translate('modal.title.inactive'), value: 'inactive' },
    ];
    const globalErrorClass = this.state.globalError !== '' ? 'show' : '';
    const ipsErrorClass = this.state.ipsError !== '' ? 'show' : '';

    const getModalContent = () => {
      if (isLoading) {
        return <Loader />;
      }
      return (
        <div className="setting_popup_contnets">
          <div className="setting_popup_content_wrap" />
          <div className="setting_popup_content_wrap">
            <table className="table">
              <colgroup>
                <col style={{ width: '15%' }} />
                <col style={{ width: '15%' }} />
                <col style={{ width: '15%' }} />
                <col style={{ width: '23.3%' }} />
                <col style={{ width: '23.3%' }} />
                <col style={{ width: '' }} />
              </colgroup>
              <tbody>
                <tr>
                  <td>
                    <h3 className="content_title">{translate('modal.title.type')}</h3>
                    <div className="setting_popup_content">
                      <div className="text_box">
                        {source === 'local' ? (
                          <Label color="green" horizontal>
                            {source}
                          </Label>
                        ) : (
                          <Label color="pink" horizontal>
                            {source}
                          </Label>
                        )}
                      </div>
                    </div>
                  </td>
                  {this.props.state.user.isAdminOnly && (
                    <td>
                      <h3 className="content_title">{translate('settings.list.permission')}</h3>
                      <div className="setting_popup_content">
                        {
                          isAuthChangable ? (
                            <div className="switch">
                              <a
                                className={cx({
                                  checked: permission === 'user',
                                })}
                                data-id="user"
                                onClick={this.handleAuthChange}
                                style={{ cursor: 'pointer' }}
                              >
                                {translate('settings.list.user')}
                              </a>
                              <a
                                className={cx({
                                  checked: permission === 'admin',
                                })}
                                data-id="admin"
                                onClick={this.handleAuthChange}
                                style={{ cursor: 'pointer' }}
                              >
                                {translate('settings.list.admin')}
                              </a>
                            </div>
                          ) : (
                            <div className="switch">
                              <a
                                className={cx({
                                  checked: permission === 'user',
                                })}
                                data-id="user"
                                style={{
                                  pointerEvents: 'none',
                                  cursor: 'default',
                                }}
                              >
                                {translate('settings.list.user')}
                              </a>
                              <a
                                className={cx({
                                  checked: permission === 'admin',
                                })}
                                data-id="admin"
                                style={{
                                  pointerEvents: 'none',
                                  cursor: 'default',
                                }}
                              >
                                {translate('settings.list.admin')}
                              </a>
                            </div>
                          )
                        }
                      </div>
                    </td>
                  )}
                  {this.props.state.user.isSuperAdmin && (
                    <td>
                      <h3 className="content_title">{translate('list.title.company')}</h3>
                      <div className="setting_popup_content">
                        <div className="text_box">{companyName}</div>
                      </div>
                    </td>
                  )}
                  <td>
                    <h3 className="content_title">{translate('settings.list.status')}</h3>
                    <div className="setting_popup_content">
                      <Dropdown
                        options={statusValue}
                        value={status}
                        onChange={this.handleStatusChange}
                        disabled={!isStatusChangable}
                      />
                    </div>
                  </td>
                  {
                    ((this.props.state.user.isAdminOnly && permission === 'admin' && isIpChangeable) || (this.props.state.user.isSuperAdmin && isIpChangeable))
                    && (
                      <td>
                        <h3 className="content_title">{translate('profile.title.authorize_user_ip')}</h3>
                        <div className="setting_popup_content">
                          <div className="inline_radio">
                            <Radio
                              label={translate('profile.title.all_ip')}
                              value="all"
                              checked={authorizedIps === 'all'}
                              onChange={this.handleRadioChange}
                            />
                            <Radio
                              label={translate('profile.title.specific_ip')}
                              value="specific"
                              checked={authorizedIps === 'specific'}
                              onChange={this.handleRadioChange}
                            />
                          </div>
                        </div>
                      </td>
                    )
                  }
                  {
                    ((this.props.state.user.isAdminOnly && permission === 'admin' && isIpChangeable) || (this.props.state.user.isSuperAdmin && isIpChangeable)) && authorizedIps === 'specific'
                    && (
                      <td>
                        <div className="setting_popup_content" style={{ position: 'relative' }}>
                          <Popup
                            trigger={<Icon name="question circle outline" />}
                            content={translate('profile.message.multiple_ip_addr')}
                            position="top left"
                            size="small"
                            className="question"
                          />
                          <input
                            type="text"
                            value={selectedIps}
                            disabled={!isIpChangeable}
                            placeholder={translate('profile.title.authorized_ip_addr')}
                            onChange={this.handleInputChange}
                          />
                          <div
                            className={`error ${ipsErrorClass}`}
                            style={{
                              marginTop: '6px',
                              marginLeft: '5px',
                              fontSize: '12px',
                              fontWeight: '700',
                              color: '#ef4136',
                            }}
                          >
                            {this.state.ipsError}
                          </div>
                        </div>
                      </td>
                    )
                  }
                  <td>&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="setting_popup_content_wrap">
            <table className="table ">
              <colgroup>
                <col style={{ width: '50%' }} />
                <col style={{ width: '50%' }} />
              </colgroup>
              <tbody>
                <tr>
                  <td>
                    <h3 className="content_title">
                      {translate('settings.list.user_name')}
                    </h3>
                    <div className="setting_popup_content">
                      <div className="text_box">{userName}</div>
                    </div>
                  </td>
                  <td>
                    <h3 className="content_title">{translate('settings.list.email')}</h3>
                    <div className="setting_popup_content">
                      <div className="text_box">{email}</div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="setting_popup_content_wrap">
            <table className="table ">
              <colgroup>
                <col style={{ width: '25%' }} />
                <col style={{ width: '25%' }} />
                <col style={{ width: '25%' }} />
                <col style={{ width: '25%' }} />
              </colgroup>
              <tbody>
                <tr>
                  <td>
                    <h3 className="content_title">{translate('settings.list.created_date')}</h3>
                    <div className="setting_popup_content">
                      <div className="text_box">{created}</div>
                    </div>
                  </td>
                  <td>
                    <h3 className="content_title">{translate('modal.cve.last_modified_date')}</h3>
                    <div className="setting_popup_content">
                      <div className="text_box">{lastModified || '-'}</div>
                    </div>
                  </td>
                  <td>
                    <h3 className="content_title">{translate('profile.title.last_accessed_date')}</h3>
                    <div className="setting_popup_content">
                      <div className="text_box">{lastAccessed || '-'}</div>
                    </div>
                  </td>
                  {this.props.state.user.isAdmin ? (
                    <td>
                      <h3 className="content_title">{translate('login.menu.password')}</h3>
                      <div className="setting_popup_content">
                        {this.resetPasswordBtn()}
                      </div>
                    </td>
                  ) : (
                    <td />
                  )}
                </tr>
              </tbody>
            </table>
          </div>
          {
            !this.props.state.user.isSuperAdmin ? (
              <div className="setting_popup_content_wrap">
                <h3 className="content_title">
                  {translate('settings.list.assigned_project')}
                  <div className="button_box">
                    <a
                      className="delete_button"
                      onClick={this.handleRemoveProject}
                      style={{ cursor: 'pointer' }}
                    >
                      {translate('modal.button.delete')}
                    </a>
                    {
                      isProjectAssignable ? (
                        <a
                          className="add_button"
                          onClick={this.handleAddProject}
                          style={{ cursor: 'pointer' }}
                        >
                          {translate('modal.button.add_project')}
                        </a>
                      ) : (
                        <a
                          className="add_button"
                          style={{
                            pointerEvents: 'none',
                            cursor: 'default',
                            opacity: '.45',
                          }}
                        >
                          {translate('modal.button.add_project')}
                        </a>
                      )
                    }
                  </div>
                </h3>
                <div className="setting_popup_content">
                  <div
                    className="table_wrap table_type_3"
                    style={{
                      padding: '0 10px',
                      border: '1px solid #e5e5e5',
                      borderRadius: '5px',
                    }}
                  >
                    <table className="table table_type_3">
                      <colgroup>
                        <col style={{ width: '36px' }} />
                        <col style={{ width: '' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '20%' }} />
                      </colgroup>
                      <tbody>
                        <tr>
                          <th>
                            <Checkbox
                              checked={itemsChecked}
                              onChange={this.handleProjectCheckAll}
                            />
                          </th>
                          <th>{translate('settings.list.project_name')}</th>
                          <th>{translate('modal.title.project_member')}</th>
                          <th>{translate('modal.title.project_owner')}</th>
                          <th className="tar">{translate('modal.title.assigned')}</th>
                        </tr>
                        {
                          assignedProject.length !== 0 ? (
                            assignedProject.map((item) => {
                              return (
                                <tr key={uuidv4()}>
                                  <td>
                                    <Checkbox
                                      value={item.id}
                                      checked={checkValue.indexOf(item.id) > -1}
                                      onChange={this.handleProjectCheckChange}
                                      disabled={item.is_project_deletable === false}
                                    />
                                  </td>
                                  <td>{item.name}</td>
                                  {
                                    item.member_count === 0 ? (
                                      <td>{item.member_count}</td>
                                    ) : (
                                      <td>
                                        <Popup
                                          trigger={<span style={{ cursor: 'pointer' }} onClick={() => { return this.getSProjectMemberDetail(item.id); }}>{item.member_count}</span>}
                                          on="click"
                                          hideOnScroll
                                          position="bottom left"
                                          open={
                                            popupStatus && activeIndex === item.id
                                          }
                                          onClose={this.handlePopupClose}
                                        >
                                          <List>
                                            {
                                              this.state.memberList.group_list.length !== 0 ? (
                                                <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                                                  <List.Header style={{ margin: '0 0 5px 0' }}>
                                                    {translate('settings.list.group')}
                                                    (
                                                    {this.state.memberList.group_list.length}
                                                    )
                                                  </List.Header>
                                                  <List.List>
                                                    {
                                                      this.state.memberList.group_list.map((group) => {
                                                        return (
                                                          <List.Item key={uuidv4()}>
                                                            <List.Icon name="group" />
                                                            <List.Content>{group}</List.Content>
                                                          </List.Item>
                                                        );
                                                      })
                                                    }
                                                  </List.List>
                                                </List.Item>
                                              ) : null
                                            }
                                            {
                                              this.state.memberList.member_list.length !== 0 ? (
                                                <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                                                  <List.Header style={{ margin: '0 0 5px 0' }}>
                                                    {translate('settings.list.user')}
                                                    (
                                                    {this.state.memberList.member_list.length}
                                                    )
                                                  </List.Header>
                                                  <List.List>
                                                    {
                                                      this.state.memberList.member_list.map((member) => {
                                                        return (
                                                          <List.Item key={uuidv4()}>
                                                            <List.Icon name="user" />
                                                            <List.Content>{member}</List.Content>
                                                          </List.Item>
                                                        );
                                                      })
                                                    }
                                                  </List.List>
                                                </List.Item>
                                              ) : null
                                            }
                                          </List>
                                        </Popup>
                                      </td>
                                    )
                                  }
                                  <td>{item.owner}</td>
                                  <td className="tar">{item.assigned || '-'}</td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="5">{translate('modal.message.need_add_project_edit')}</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : (
              <div className="setting_popup_content_wrap">
                <h3 className="content_title">
                  {translate('settings.list.assigned_project')}
                </h3>
                <div className="setting_popup_content">
                  <div
                    className="table_wrap table_type_3"
                    style={{
                      padding: '0 10px',
                      border: '1px solid #e5e5e5',
                      borderRadius: '5px',
                    }}
                  >
                    <table className="table table_type_3">
                      <colgroup>
                        <col style={{ width: '36px' }} />
                        <col style={{ width: '' }} />
                        <col style={{ width: '200px' }} />
                        <col style={{ width: '200px' }} />
                      </colgroup>
                      <tbody>
                        <tr>
                          <th>
                            &nbsp;
                          </th>
                          <th>{translate('settings.list.project_name')}</th>
                          <th>{translate('modal.title.project_member')}</th>
                          <th>{translate('modal.title.project_owner')}</th>
                          <th className="tar">{translate('modal.title.assigned')}</th>
                        </tr>
                        <tr>
                          <td colSpan="5">{translate('modal.message.permission_access_project')}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )
          }
          <div className="setting_popup_bottom">
            {
              this.props.state.user.isAdmin && this.deleteThisUserBtn()
            }
          </div>
        </div>
      );
    };

    return (
      <Modal
        open={this.state.isOpenMEU}
        onClose={this.closeEditUserModal}
      >
        <div className="setting_popup_wrap">
          <div className="setting_popup default_popup">
            <div className="setting_popup_header">
              <h2 className="popup_name">{translate('modal.title.user_detail')}</h2>
              <div
                className={`error ${globalErrorClass}`}
                style={{
                  fontSize: '15px',
                  fontWeight: '700',
                  color: '#ef4136',
                }}
              >
                {this.state.globalError}
              </div>
              <a className="popup_close_button" style={{ cursor: 'pointer' }} onClick={this.closeEditUserModal}>
                <img
                  src={closeBtn}
                  alt=""
                />
              </a>
            </div>
            <Scrollbars
              onScroll={this.handleScroll}
            >
              {
                isLoading ? null : (
                  <div className="setting_popup_inner_header">
                    <div className="user_avata" style={{ pointerEvents: 'none' }}>
                      <img
                        className="profileImg"
                        src={this.getProfileImg(this.props.userId)}
                        role="presentation"
                        alt=""
                      />
                    </div>
                  </div>
                )
              }
              {getModalContent()}
            </Scrollbars>
            {
              isLoading ? null : (
                <div className="setting_popup_button_wrap">
                  <a
                    className="button cencel_button"
                    onClick={this.closeEditUserModal}
                    style={{ cursor: 'pointer' }}
                  >
                    {translate('modal.button.cancel')}
                  </a>
                  <a
                    className="button save_button"
                    onClick={this.handleSave}
                    style={{ cursor: 'pointer' }}
                  >
                    {translate('modal.button.save')}
                  </a>
                </div>
              )
            }
          </div>
        </div>
        <DeleteProjectModal
          isOpenMDP={this.state.isOpenMDP}
          closeModal={this.handleMDPClose}
          completeCallback={this.handleDeleteCallback}
          location={this.props.location}
          data={this.props.userId}
          status={this.state.isOpenMEU}
          translate={translate}
        />
        <AssigningProjectModal
          isOpenMAP={this.state.isOpenMAP}
          isOpenMEU={this.state.isOpenMEU}
          closeModal={this.handleMAPClose}
          projects={assignedProject}
          completeCallback={this.handleProjectList}
          translate={translate}
        />
        <Modal
          open={this.state.modalIsOpen}
          onClose={this.closeResetModal}
        >
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              {
                this.state.isShowLoader ? (
                  <Loader />
                  /*
                  <div className="modal_popup">
                    <h2 className="title">Attention</h2>
                    <Dimmer active style={{ borderRadius: '20px' }}>
                      <Loader style={{ paddingTop: '100px' }} size="huge" inline="centered">Loading ... Please wait</Loader>
                    </Dimmer>
                  </div>
                   */
                ) : (
                  <div className="modal_popup">
                    <h2 className="title">{this.modalAction}</h2>
                    <p className="text">{this.modalBody}</p>
                    {this.modalBtn()}
                  </div>
                )
              }
            </div>
          </div>
        </Modal>
        <Modal open={this.state.modalAlert} onClose={this.handleCloseAlert}>
          {this.state.isLoader ? (
            <Loader />
          ) : (
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.state.modalAlertTitle}</h2>
                  <p className="text">{this.state.modalAlertMsg}</p>
                  <div className="button_wrap">
                    <a
                      onClick={this.handleCloseAlert}
                      className="center_button"
                    >
                      {translate('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(EditUserModal)));
